const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('olySrNotification', [require('./sr-notification-directive.js')]);
wowApp.directive('wowAccessibilityNavLinks', ['BreakpointsService', require('./accessibility-nav-links-directive.js')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/accessiblity/index.js
 **/